import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { APP_TYPES } from '@config';
import './../../index.scss';

import Spinner from '@components/LoadingStyles/Spinner';

import InputWithSelect from '@components/InputWithSelect';
import { APP_TEXTS } from '../../texts/texts';
import { APP_TOOLTIPS } from '../../../src/texts/tooltips';
import { Tooltip } from '../../components/Tippy/index';

// const ROTATE_DIRECTION = {
//   LEFT: 'left',
//   RIGHT: 'right'
// };

class MaterialSelector extends Component {

  static propTypes = {
    material: PropTypes.any,
    onMaterialSelect: PropTypes.func.isRequired,
    family: PropTypes.any,
    onFamilySelect: PropTypes.func,
    size: PropTypes.any,
    onSizeSelect: PropTypes.func,
    setProfileRotation: PropTypes.func,
    profileRotation: PropTypes.any,
    // setRotateDirection: PropTypes.func,
    // profileRotateDirection: PropTypes.string
  };

  // constructor(props) {
  //   super(props);

    // props.getMaterialNames();
    // props.getProfileTypes().then(async () => {
    //   await props.getProfileSizes(props.family);
    //   if (props.family === 'None')
    //     this.props.deleteProfile();
    //   else   
    //     await props.getProfileShape(props.family, props.size);
        
    //   this.props.setSpinner(false);
    // });
  // }

  onFamilySelect = (e) => {
    this.props.setSpinner(true);
    const chosenProfile = e.target.value;

    this.props.onFamilySelect(chosenProfile);

    this.props.getProfileSizes(chosenProfile).then((res) => {
      if (res && res.length) {
          // Set as selected value
          this.props.onSizeSelect(res[0].InternalName);
    
          this.props.getProfileShape(chosenProfile, this.props.size)
          .then(this.props.setSpinner(false));
      }
      else {
        this.props.deleteProfile();
        this.props.setSpinner(false);
      }
    });
  };

  onSizeSelect = (e) => {
    const size = e.target.value;

    this.props.onSizeSelect(size);

    this.props.getProfileShape(this.props.family, size);
  };

  // unsetPending = () => this.setState({ isPending: false });

  render() {
    //var string = APP_TEXTS.APPLICATIONS_LABEL_PLATE_MATERIAL_STEEL_GRADE.Content;
    return (
      <div>
        { this.props.isPending && <Spinner /> } 

        <h4>{APP_TEXTS.APPLICATIONS_LABEL_PLATE_MATERIAL_STEEL_GRADE.Content}</h4>
        <label htmlFor="material">
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_PLATE_MATERIAL_SELECT.Content}>
              <select
                id="material"
                className="form-control w-75 mr-2 mb-2 ml-0"
                onChange={(e) => this.props.onMaterialSelect(e.target.value)}
                value={this.props.material || ''}
                disabled={this.props.predefinedBasePlate && this.props.predefinedBasePlate.isPredefinedBasePlate}
              >
                {this.props.materialNames && this.props.materialNames.length && this.props.materialNames.map(n => (
                  <option 
                    // selected={this.props.material === n['InternalName']}
                    value={n['InternalName']} 
                    key={n['InternalName']}
                  >
                    {n['RunName']}
                  </option>
                ))}
              </select>
          </Tooltip>
        </label>

            {this.props.onFamilySelect && (
                <div>
        <h4>{APP_TEXTS.APPLICATIONS_LABEL_PROFILE_FAMILY.Content}</h4>
        <label htmlFor="family">
         <Tooltip content={APP_TOOLTIPS.TOOLTIP_PROFILE_FAMILY_SELECT.Content} >
           <select
            id="family"
            className="form-control w-75 mr-2 mb-2 ml-0"
            onChange={this.onFamilySelect}
            value={this.props.family || ''}
            disabled={this.props.predefinedBasePlate && this.props.predefinedBasePlate.isPredefinedBasePlate}
          >
            {this.props.profileTypes && this.props.profileTypes.length && this.props.profileTypes.map(n => (
              <option
                // selected={this.props.family === n['InternalName']}
                value={n['InternalName']}
                key={n['InternalName']}
              >
                {n['RunName']}
              </option>
            ))}
           </select>
         </Tooltip>
                    </label>
                </div>
            )}

            {this.props.onSizeSelect && this.props.family && (
                <div>
        <h4>{APP_TEXTS.Applications_LABEL_PROFILE_SIZE.Content}</h4>
        <label htmlFor="size">
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_PROFILE_SIZE_SELECT.Content}>
          <select
            id="size"
            className="form-control w-75 mr-2 mb-2 ml-0"
            onChange={this.onSizeSelect}
            value={this.props.size || ''}
            disabled={this.props.predefinedBasePlate && this.props.predefinedBasePlate.isPredefinedBasePlate}
          >
            {this.props.profileSizes && this.props.profileSizes.length && this.props.profileSizes.map(n => (
              <option
                // selected={this.props.size === n['InternalName']}
                value={n['InternalName']}
                key={n['InternalName']}
              >
                {n['RunName']}
              </option>
            ))}
          </select>
        </Tooltip>
                    </label>
                </div>
            )}

        {this.props.appType === APP_TYPES.GENERAL_CALCULATION && (
          <div>
            <h4>{APP_TEXTS.GENERAL_CALCULATION_PROFILE_ORIENTATION.Content}</h4>
            <div className="d-flex w-75 mt-2">
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_ROTATION_ANGLE.Content}>
                <InputWithSelect
                  options={[ 0, 45, 90, 135, 180, 225, 270, 315, 360 ]}
                  value={this.props.profileRotation}
                  onChange={value => this.props.setProfileRotation(Number(value) || 0)}
                />
              </Tooltip>
            </div>
          </div>
        )}
      </div>
    );
  }

}

export default MaterialSelector;




// WEBPACK FOOTER //
// ./src/components/MaterialSelector/MaterialSelector.js